import { useEffect, useRef } from 'react';
import { App as CapacitorApp } from '@capacitor/app';
import { useLocation, useNavigate } from 'react-router-dom';

const BackButtonHandler = () => {
    const location = useLocation();
    const navigate = useNavigate();
    // Keep latest location in a ref so listener always has access to current state
    // without needing to re-register on every route change
    const locationRef = useRef(location);

    useEffect(() => {
        locationRef.current = location;
    }, [location]);

    useEffect(() => {
        let backButtonListener;

        const setupListener = async () => {
            backButtonListener = await CapacitorApp.addListener('backButton', () => {
                const currentPath = locationRef.current.pathname;

                // Check if we are on the root or dashboard page
                if (currentPath === '/' || currentPath === '/dashboard') {
                    // Prompt user to confirm exit
                    const confirmExit = window.confirm('Do you really want to exit the app?');
                    if (confirmExit) {
                        CapacitorApp.exitApp();
                    }
                } else {
                    // Go back one step in history
                    navigate(-1);
                }
            });
        };

        setupListener();

        return () => {
            if (backButtonListener) {
                backButtonListener.remove();
            }
        };
    }, [navigate]);

    return null;
};

export default BackButtonHandler;
